import React, { forwardRef } from 'react';

import Searcher from 'components/DesignSystem/Searcher';
import DatePicker from 'components/DatePicker';
import Icon from 'components/DesignSystem/Icon';
import { onDatePickerChange } from 'helper/controlledField';
import { cssVar } from 'constants/theme';

interface DateButtonProps {
  value?: string;
  active: boolean;
  onClick?: () => void;
}

// customInput do react-datepicker: precisa encaminhar ref + onClick.
const DateButton = forwardRef<HTMLButtonElement, DateButtonProps>(
  ({ value, active, onClick }, ref) => (
    <button
      type="button"
      ref={ref}
      onClick={onClick}
      className={`videos-mobile-date${active ? ' active' : ''}`}
    >
      <Icon iconType="calendar" color={cssVar(active ? 'text-strong' : 'text-secondary')} size="small" />
      <span>{active ? value : 'Data'}</span>
    </button>
  ),
);

export default function FilterBar({
  searchValue,
  onSearchChange,
  setSearchQuery,
  selectedDate,
  onDateChange,
}: {
  searchValue: string;
  onSearchChange: React.ChangeEventHandler<HTMLInputElement>;
  setSearchQuery: (text: string) => void;
  selectedDate: Date | null;
  onDateChange: React.Dispatch<React.SetStateAction<Date | null>>;
}) {
  return (
    <div className="videos-mobile-filter">
      <Searcher
        className="videos-mobile-search"
        value={searchValue}
        onChange={onSearchChange}
        setSearchQuery={setSearchQuery}
        placeholder="Pesquisar"
      />
      <DatePicker
        selected={selectedDate}
        onChange={onDatePickerChange(onDateChange)}
        isClearable
        withPortal
        containerClass="videos-mobile-date-container"
        customInput={<DateButton active={selectedDate !== null} />}
      />
    </div>
  );
}
